import { render, staticRenderFns } from "./Desconto.vue?vue&type=template&id=2c20f400&"
import script from "./Desconto.vue?vue&type=script&lang=js&"
export * from "./Desconto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports